/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/main/LICENSE.md for details.
 * v1.9.2
 */
import { I as Icon, d as defineCustomElement$1 } from './icon.js';

const CalciteIcon = Icon;
const defineCustomElement = defineCustomElement$1;

export { CalciteIcon, defineCustomElement };
